import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useThemeMode } from '../contexts/ThemeContext';
import { onboardingService } from '../services/onboardingService';
import UnifiedTalentTreeView from '../components/UnifiedTalentTreeView';
import LoadingErrorBoundary from '../components/LoadingErrorBoundary';

const HealthTree: React.FC = () => {
  const { user } = useAuth();
  const { mode: themeMode } = useThemeMode();

  // No longer need to handle URL params for mode switching

  // Track that user visited the health tree for onboarding
  useEffect(() => {
    if (user?.id) {
      const markVisited = async () => {
        try {
          await onboardingService.markHealthTreeVisited(user.id);
        } catch (error) {
          console.error('Error marking health tree as visited:', error);
        }
      };
      markVisited();
    }
  }, [user?.id]);

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        backgroundColor: themeMode === 'dark' ? '#0a0a0a' : '#f5f5f5',
        position: 'relative'
      }}
    >
      {/* Main Talent Tree View - Simplified to explore mode only */}
      <LoadingErrorBoundary 
        timeout={20000} 
        onTimeout={() => console.warn('UnifiedTalentTreeView loading timed out')}
      >
        <UnifiedTalentTreeView />
      </LoadingErrorBoundary>

      {/* Loading State */}
      {!user && (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            zIndex: 1000
          }}
        >
          <Typography variant="h6" color="text.secondary">
            Loading your health tree...
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default HealthTree;